import { E as EMPTY_VALUES } from './constants-8d548297.js';
import { c as checkOneOf } from './check-one-of-6b3ef8eb.js';

function emptyOr(check) {
    return (...args) => {
        const value = args[0];
        if (!EMPTY_VALUES.some(v => v === value))
            check(...args);
    };
}

function checkPattern(value, pattern, errorMessage) {
    if (typeof value !== 'string' || !pattern.test(value))
        throw new Error(errorMessage);
}

function checkType(value, type, error) {
    const typeIsArray = type === 'array';
    const valueIsArray = Array.isArray(value);
    if (typeIsArray || valueIsArray) {
        if (valueIsArray !== typeIsArray)
            throw new Error(error);
    }
    else {
        if (typeof value !== type)
            throw new Error(error);
    }
}

function checkUrl(value, error) {
    if (typeof value !== 'string' && !(value instanceof URL))
        throw new Error(error);
    try {
        new URL(value);
    }
    catch (e) {
        throw new Error(error);
    }
}

const checkEmptyOrOneOf = emptyOr(checkOneOf);
const checkEmptyOrPattern = emptyOr(checkPattern);
const checkEmptyOrType = emptyOr(checkType);
const checkEmptyOrUrl = emptyOr(checkUrl);

export { checkType as a, checkEmptyOrPattern as b, checkEmptyOrOneOf as c, checkEmptyOrType as d, checkEmptyOrUrl as e };
